import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DialogDetailComponent} from '../dialog-detail/dialog-detail.component';
import {ProjectConstants} from '../../project-constants';
import {PriceRangeModel} from '../../../models/PriceRangeModel';

@Component({
  selector: 'app-dialog-price-range',
  templateUrl: './dialog-price-range.component.html',
  styleUrls: ['./dialog-price-range.component.scss']
})
export class DialogPriceRangeComponent extends ProjectConstants implements OnInit {

  dataValues: Array<any>;
  data: any;
  priceRangeList: Array<PriceRangeModel>;

  constructor(public dialogData: MatDialogRef<DialogDetailComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    super();
    this.dataValues = data.list;
    this.priceRangeList = JSON.parse(this.dataValues[0].value);
  }

  ngOnInit() {

  }

  close() {
    this.dialogData.close();
  }

}
